export const BAND_INCREMENTS = 10;

export type Band = { id: string; label: string; min: number; max: number };

export default function generateBands(minBand: number, maxBand: number): Band[] {
  const roundedMin = Math.floor(minBand / BAND_INCREMENTS) * BAND_INCREMENTS;
  const roundedMax = Math.ceil(maxBand / BAND_INCREMENTS) * BAND_INCREMENTS;

  return [
    {
      id: `${roundedMin}`,
      label: `${roundedMin} and below`,
      min: roundedMin - BAND_INCREMENTS,
      max: roundedMin
    },
    ...Array.from({ length: (roundedMax - roundedMin) / BAND_INCREMENTS }, (_, i) => {
      const startRange = roundedMin + i * BAND_INCREMENTS;
      const endRange = startRange + BAND_INCREMENTS;

      return {
        id: `${startRange}-${endRange}`,
        label: `${startRange}-${endRange}`,
        min: startRange,
        max: endRange
      };
    }),
    {
      id: `${roundedMax}`,
      label: `${roundedMax} and above`,
      min: roundedMax,
      max: roundedMax + BAND_INCREMENTS
    }
  ];
}
